import React from "react";
import clsx from "clsx";
import planColorMap from "./planColors";
import {
  ShieldCheckIcon
} from "@heroicons/react/24/outline";

const PlanBadge = ({ value }) => {
//   const upperValue = (value || "").toUpperCase();
  const plan = planColorMap[value] || { label: value || "UNKNOWN", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" };

  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold",
      )}
      style={{
        background: plan.gradient,   // gradient background
        color: "#fff",
        borderRadius: "8px",
      }}
    >
       <ShieldCheckIcon className="h-5 w-5 mr-1" />{value}
    </span>
  );
};

export default PlanBadge;
